import { isUnavailableWhenMaintenanceMode } from '@/utils/regUrl';
import { Retry } from '@/utils/retry';
export default defineNuxtRouteMiddleware(async (to) =>
  // to
  {
    // server側での実行を回避する
    if (process.server) return;
    // ローカルでは動作しないので無効化
    const url = useRequestURL();
    if (url.hostname === 'localhost') return;

    const runtimeConfig = useRuntimeConfig();
    // 動作確認のため、staging環境ではメンテナンスモードを無効化
    if (runtimeConfig.public.env === 'staging') return;
    if (runtimeConfig.public.env === 'local') return;
    try {
      const retry = new Retry();
      const response = await retry.execute(() => fetch('/isMaintenance', { method: 'GET' }));

      const text = await response.text();
      // サイト全体をメンテナンスモードにする場合は、ページに関わらずメンテナンスページにリダイレクト
      if (to.path !== '/maintenance/' && text === 'IS_FULL_PAGES_MAINTENANCE_MODE') {
        return navigateTo({ path: '/maintenance/' });
      }

      if (isUnavailableWhenMaintenanceMode(to.path)) {
        if (text === 'IS_MAINTENANCE_MODE') {
          return navigateTo({ path: '/maintenance/' });
        }
        return;
      }
    } catch {
      // 疎通に失敗した時は何もせずreturnする
      return;
    }
  },
);
